module.exports = __webpack_public_path__ + "static/media/forest.a26ef035.webp";